import React from "react";

interface AccentDotProps {
  className?: string;
}

export const AccentDot: React.FC<AccentDotProps> = ({ className = "bg-coral" }) => (
  <span
    aria-hidden
    className={`inline-block rounded-full align-baseline ${className}`}
    style={{ width: "0.18em", height: "0.18em", marginLeft: "0.04em" }}
  />
);
